import { FC } from "react";
import { Button } from "./ui/button";
import { Clock5 } from "lucide-react";

interface Props {
  sessionName: string;
  sessionDescription: string;
  startSession: ()=>void;
}

const TrackSessionHeader: FC<Props> = ({ sessionName, sessionDescription, startSession }) => {
  return (
    <div>
      <div className="w-full flex justify-between items-center">
        <div className="flex flex-col w-[487px] gap-3">
          <h6 className="m-0 p-0 text-[#0F0C09] text-[20px] font-medium">
            {sessionName}
          </h6>
          <p className="m-0 p-0 text-[14px] text-[#0F0C09]">
            {sessionDescription}
          </p>
        </div>
        <Button onClick={startSession} className="shadow-none">
          Start Session
        </Button>
        {/* <Button className="shadow-none">
          <Clock5 />
          Interview Timer On
        </Button> */}
      </div>
    </div>
  );
};

export default TrackSessionHeader;
